export class SpeedometerModel
{
    configure: any;
    isRendered: any;
    render: any;
    update: any;
}